<template>
  <div class="view-container faq-container">
    <div class="extended-filter-block">
      <h2>Помощь с ЛК</h2>
    </div>
<!--    <div class="card">-->
<!--      <div class="search-header">Что вы хотите найти?</div>-->
<!--      <div class="search-block">-->
<!--        <a-input-->
<!--            v-model:value="searchString"-->
<!--            class="search-input"-->
<!--            placeholder="Выдать доступы"-->
<!--            :allowClear="true"-->
<!--            @pressEnter.prevent="runSearch"-->
<!--        >-->
<!--          <template #suffix>-->
<!--            <SearchOutlined class="search-icon" />-->
<!--          </template>-->
<!--        </a-input>-->

<!--        <a-button @click="runSearch" class="primary-button">-->
<!--          Найти-->
<!--        </a-button>-->
<!--      </div>-->
<!--    </div>-->

    <div class="faq-main-wrapper">
<!--      <div class="desktop-navigation">-->
<!--        <FaqSideNavigation />-->
<!--      </div>-->

<!--      <div class="mobile-navigation">-->
<!--        <FaqMobileNav />-->
<!--      </div>-->

      <video class="video-instruction" src="https://crm-upload.storage.yandexcloud.net/disk/f26/f264673a6452ecb608ab07fc1a9e4ed2/eebce515e616cb4d74933372074d3fc9"
             controls
             preload="metadata"
      ></video>

<!--      <div class="card">-->
<!--        <div class="faq-content">-->
<!--          -->
<!--&lt;!&ndash;          <section v-if="currentBlock">&ndash;&gt;-->
<!--&lt;!&ndash;            <h1>{{ currentBlock.mainHeader }}</h1>&ndash;&gt;-->

<!--&lt;!&ndash;            <template&ndash;&gt;-->
<!--&lt;!&ndash;                v-for="(item, i) in visibleItems"&ndash;&gt;-->
<!--&lt;!&ndash;                :key="`${routeState.block}-${routeState.section ?? 'all'}-${i}`"&ndash;&gt;-->
<!--&lt;!&ndash;            >&ndash;&gt;-->
<!--&lt;!&ndash;              <h2 v-if="item.type === 'h2'">{{ item.value }}</h2>&ndash;&gt;-->

<!--&lt;!&ndash;              <h2 v-else-if="item.type === 'section-title'">{{ item.value }}</h2>&ndash;&gt;-->

<!--&lt;!&ndash;              <h3 v-else-if="item.type === 'h3'">{{ item.value }}</h3>&ndash;&gt;-->

<!--&lt;!&ndash;              <p v-else-if="item.type === 'text'">{{ item.value }}</p>&ndash;&gt;-->

<!--&lt;!&ndash;              <small v-else-if="item.type === 'caption'" class="caption">&ndash;&gt;-->
<!--&lt;!&ndash;                {{ item.value }}&ndash;&gt;-->
<!--&lt;!&ndash;              </small>&ndash;&gt;-->

<!--&lt;!&ndash;              <p v-else-if="item.type === 'link'">&ndash;&gt;-->
<!--&lt;!&ndash;                <a&ndash;&gt;-->
<!--&lt;!&ndash;                    :href="item.href"&ndash;&gt;-->
<!--&lt;!&ndash;                    target="_blank"&ndash;&gt;-->
<!--&lt;!&ndash;                    rel="noopener"&ndash;&gt;-->
<!--&lt;!&ndash;                    class="green-link"&ndash;&gt;-->
<!--&lt;!&ndash;                >&ndash;&gt;-->
<!--&lt;!&ndash;                  {{ item.text }}&ndash;&gt;-->
<!--&lt;!&ndash;                </a>&ndash;&gt;-->
<!--&lt;!&ndash;              </p>&ndash;&gt;-->

<!--&lt;!&ndash;              <ul v-else-if="item.type === 'list'">&ndash;&gt;-->
<!--&lt;!&ndash;                <li v-for="(li, j) in item.items" :key="j">{{ li }}</li>&ndash;&gt;-->
<!--&lt;!&ndash;              </ul>&ndash;&gt;-->
<!--&lt;!&ndash;            </template>&ndash;&gt;-->
<!--&lt;!&ndash;          </section>&ndash;&gt;-->

<!--&lt;!&ndash;          <div v-if="profile">&ndash;&gt;-->
<!--&lt;!&ndash;            <div v-if="profile === 'superadmin'">&ndash;&gt;-->
<!--&lt;!&ndash;              Показаны варианты FAQ для всех ролей&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->

<!--&lt;!&ndash;            <div class="admin-hint" v-if="profile === 'superadmin'">&ndash;&gt;-->
<!--&lt;!&ndash;              Сотрудник&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->

<!--&lt;!&ndash;            <StaffFAQ v-if="profile === 'staff' || profile === 'superadmin'" />&ndash;&gt;-->

<!--&lt;!&ndash;            <div class="admin-hint" v-if="profile === 'superadmin'">&ndash;&gt;-->
<!--&lt;!&ndash;              Юридическое лицо&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->

<!--&lt;!&ndash;            <AdminFAQ v-if="profile === 'admin' || profile === 'superadmin'" />&ndash;&gt;-->

<!--&lt;!&ndash;            <div class="admin-hint" v-if="profile === 'superadmin'">&ndash;&gt;-->
<!--&lt;!&ndash;              Физическое лицо&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->

<!--&lt;!&ndash;            <PhysicalFAQ&ndash;&gt;-->
<!--&lt;!&ndash;                v-if="profile === 'private_person' || profile === 'superadmin'"&ndash;&gt;-->
<!--&lt;!&ndash;            />&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { SearchOutlined } from "@ant-design/icons-vue";

import PhysicalFAQ from "./PhysicalFAQ.vue";
import AdminFAQ from "./AdminFAQ.vue";
import StaffFAQ from "./StaffFAQ.vue";
import FaqSideNavigation from "@/components/FAQ/FaqSideNavigation.vue";
import FaqMobileNav from "@/components/FAQ/FaqMobileNav.vue";

import { faqBlocks } from "@/mixins/faqText";
import {
  DEFAULT_FAQ_BLOCK,
  blockHasSections,
  getFaqRouteLocation,
  normalizeFaqParams,
  readRouteParam,
} from "@/views/FAQ/faqRouteHelper";

const buildBlockModel = (block) => {
  const sections = new Map();
  const sharedItems = [];
  let currentSection = null;

  block.innerBlocks.forEach((item) => {
    if (item.type === "section") {
      currentSection = {
        value: item.value,
        title: item.title,
        items: item.title
            ? [{ type: "section-title", value: item.title }]
            : [],
      };

      sections.set(item.value, currentSection);
      return;
    }

    if (currentSection) {
      currentSection.items.push(item);
      return;
    }

    sharedItems.push(item);
  });

  return {
    ...block,
    sections,
    sharedItems,
    hasSections: sections.size > 0,
  };
};

const blockMap = new Map(
    faqBlocks.blocks.map((block) => [block.block, buildBlockModel(block)])
);

const createSearchRegExp = (value) => {
  return new RegExp(value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i");
};

const findRouteBySearch = (value) => {
  const matcher = createSearchRegExp(value);

  for (const block of faqBlocks.blocks) {
    const hasSections = block.innerBlocks.some((item) => item.type === "section");
    let currentSection = hasSections ? null : null;

    if (matcher.test(block.mainHeader ?? "")) {
      return getFaqRouteLocation(block.block, currentSection);
    }

    for (const item of block.innerBlocks) {
      if (item.type === "section") {
        currentSection = item.value;

        if (matcher.test(item.title ?? "")) {
          return getFaqRouteLocation(block.block, currentSection);
        }

        continue;
      }

      if (Array.isArray(item.items)) {
        for (const listItem of item.items) {
          if (typeof listItem === "string" && matcher.test(listItem)) {
            return getFaqRouteLocation(block.block, currentSection);
          }
        }
      }

      const haystack = item.value ?? item.text ?? "";

      if (typeof haystack === "string" && matcher.test(haystack)) {
        return getFaqRouteLocation(block.block, currentSection);
      }
    }
  }

  return null;
};

export default {
  name: "FAQ",
  components: {
    PhysicalFAQ,
    AdminFAQ,
    StaffFAQ,
    FaqSideNavigation,
    FaqMobileNav,
    SearchOutlined,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const profile = computed(() => store.state.profile.profile?.role);
    const searchString = ref("");

    const routeState = computed(() => normalizeFaqParams(route.params));

    watch(
        [() => route.params.block, () => route.params.section],
        () => {
          const block = readRouteParam(route.params.block);
          const section = readRouteParam(route.params.section);

          if (block !== routeState.value.block || section !== routeState.value.section) {
            router.replace(
                getFaqRouteLocation(routeState.value.block, routeState.value.section)
            );
          }
        },
        { immediate: true }
    );

    const currentBlock = computed(
        () => blockMap.get(routeState.value.block) ?? blockMap.get(DEFAULT_FAQ_BLOCK)
    );

    const currentSection = computed(() => {
      if (!currentBlock.value?.hasSections) {
        return null;
      }

      return currentBlock.value.sections.get(routeState.value.section) ?? null;
    });

    const visibleItems = computed(() => {
      if (!currentBlock.value) {
        return [];
      }

      if (!currentBlock.value.hasSections) {
        return currentBlock.value.sharedItems;
      }

      if (!currentSection.value) {
        return [];
      }

      return [
        ...currentBlock.value.sharedItems,
        ...currentSection.value.items,
      ];
    });

    const runSearch = () => {
      const query = searchString.value.trim();

      if (!query) {
        router.push(getFaqRouteLocation(DEFAULT_FAQ_BLOCK));
        return;
      }

      const targetRoute = findRouteBySearch(query);

      if (targetRoute) {
        router.push(targetRoute);
      }
    };

    return {
      profile,
      searchString,
      routeState,
      currentBlock,
      visibleItems,
      runSearch,
    };
  },
};
</script>


<style lang="scss" scoped>
.admin-hint {
  border-bottom: 1px solid var(--main-color);
  border-top: 1px solid var(--main-color);
  padding: 10px;
  margin: 20px 0;
}

.view-container {
  padding-top: 0;
}

.search-header {
  margin-bottom: 12px;
  font-weight: 600;
  font-size: 16px;
}

.search-block {
  display: flex;
  gap: 8px;
}

.faq-container {
  h1 {
    font-weight: 600;
    font-size: 24px;
    line-height: 120%;
  }

  h2 {
    font-weight: 600;
    font-size: 16px;
    line-height: 120%;
  }

  h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 120%;
  }

  p, ul {
    font-weight: 400;
    font-size: 14px;
    line-height: 120%;
  }

  .green-link {
    color: var(--main-green);
    cursor: pointer;
  }

  .green-link:hover {
    color: var(--hover-green);
  }

  .caption {
    color: var(--grey-text);
  }

  .faq-main-wrapper {
    display: flex;
    gap: 16px;

    @media (max-width: $tablet-breakpoint) {
      flex-direction: column;
    }
  }

  .desktop-navigation {
    width: 255px;
    min-width: 255px;

     @media (max-width: $tablet-breakpoint) {
       display: none;
     }
  }

  .mobile-navigation {
    display: none;
    @media (max-width: $tablet-breakpoint) {
      display: block;
    }
  }
}

.extended-filter-block {
  display: none;

  @media (max-width: $mobile-breakpoint) {
    margin: 24px 20px;
    display: flex;
    column-gap: 25px;
    align-items: center;
    justify-content: space-between;
  }
}

.extended-filter-block h2 {
  font-size: 20px;
  margin-bottom: 0;
  font-weight: 600;
  line-height: 120%;
}

.video-instruction {
  border-radius: 16px;
  width: 100%;
  max-width: 1000px;
  min-height: 585px;

  @media (max-width: $tablet-breakpoint) {
    min-height: 300px;
  }

  @media (max-width: $mobile-breakpoint) {
    min-height: 150px;
  }
}
</style>

<style>
.video_instruction {
  width: 100%;
}

@media (max-width: 1180px) {
  .video_instruction {
    width: 100%;
    height: 100%;
  }
}
</style>
